import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { Messages } from '../../gen-src/Localize';
import { IconFillColors } from '../styles/Colors';
import { ImgAttrs } from '../utils/HtmlAttrs';
import { Img } from '../widgets/DomWidgets';
import { encodeSvg } from './Icons';

export type StatusIconType = 'error' | 'warning' | 'success' | 'info';

export const SuccessSvg = (fill: string = IconFillColors.Valid) => `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path fill="${fill}" fill-rule="evenodd" d="M12.0713218,-2.66453526e-14 L12.865698,0.435932596 L6.33039459,12.2578763 C6.2968669,12.3177578 6.25156942,12.3670935 6.19894324,12.4046227 L6.12638767,12.4471038 L6.10956871,12.4542337 C5.9448756,12.5309428 5.74233651,12.50338 5.60334716,12.3704999 L-8.8817842e-16,7.12660356 L0.630925776,6.4797854 L5.81515537,11.3228296 L12.0713218,-2.66453526e-14 Z"/>
  </svg>`;

export const InfoSvg = (fill: string = IconFillColors.Info) => `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path fill="${fill}" fill-rule="evenodd" d="M6.5,0 C10.1,0 13,2.9 13,6.5 C13,10.1 10.1,13 6.5,13 C2.9,13 0,10.1 0,6.5 C0,2.9 2.9,0 6.5,0 Z M6.5,1 C3.5,1 1,3.5 1,6.5 C1,9.5 3.5,12 6.5,12 C9.5,12 12,9.5 12,6.5 C12,3.5 9.5,1 6.5,1 Z M7,5 L7,10 L6,10 L6,5 L7,5 Z M7,3 L7,4 L6,4 L6,3 L7,3 Z"/>
  </svg>`;

export const WarningSvg = (fill: string = IconFillColors.Warning) => `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g fill="none" fill-rule="evenodd">
      <path fill="${fill}" d="M5.7630034,1.44919786 L0.0765242105,11.7165775 C-0.181952117,12.315508 0.248841762,13 0.851953191,13 L12.1387528,13 C12.828023,13 13.1726581,12.315508 12.9141818,11.7165775 L7.22770259,1.44919786 C6.96922626,0.85026738 6.10763851,0.85026738 5.7630034,1.44919786 Z"/>
      <path fill="#000" d="M7,11 L7,12 L6,12 L6,11 L7,11 Z M7,4 L7,10 L6,10 L6,4 L7,4 Z"/>
    </g>
  </svg>`;

export const ErrorSvg = (fill: string = IconFillColors.Error) => `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path fill="${fill}" fill-rule="evenodd" d="M6.5,0 C10.1,0 13,2.9 13,6.5 C13,10.1 10.1,13 6.5,13 C2.9,13 0,10.1 0,6.5 C0,2.9 2.9,0 6.5,0 Z M10.7126852,2.99396754 L2.99396754,10.7126852 C3.9509961,11.5137006 5.17686811,12 6.5,12 C9.5,12 12,9.5 12,6.5 C12,5.17686811 11.5137006,3.9509961 10.7126852,2.99396754 Z M6.5,1 C3.5,1 1,3.5 1,6.5 C1,7.82313189 1.48629945,9.0490039 2.28731479,10.0060325 L10.0060325,2.28731479 C9.0490039,1.48629945 7.82313189,1 6.5,1 Z"/>
  </svg>`;

const ImgSrcMap: { [key in StatusIconType]: string } = {
  error: encodeSvg(ErrorSvg()),
  warning: encodeSvg(WarningSvg()),
  info: encodeSvg(InfoSvg()),
  success: encodeSvg(SuccessSvg()),
};

const StatusIconStyleName: string = TypeStyle.style({
  height: 14,
  width: 14,
});

function getAltText(type: StatusIconType): string {
  // tslint:disable-next-line:no-any
  const str: string = (Messages as any)[type + 'ToastPrefix']();
  return str.substring(0, str.indexOf(':'));
}

export const StatusIcon: React.FC<{ type: StatusIconType } & ImgAttrs> = ({ type, ...htmlAttrs }) =>
  <Img
    alt={getAltText(type)}
    key={`${type}_statusIcon`}
    src={ImgSrcMap[type]}
    title={getAltText(type)}
    {...htmlAttrs}
    className={TypeStyle.classes(htmlAttrs.className, StatusIconStyleName)}
  />;
